import auth from '../middleware/auth'

var changeCase = require('change-case')

const List = () => import('../components/List').then(m => m.default || m)
const AutoForm = () => import('../components/AutoForm').then(m => m.default || m)
const Step = require('../pages/step')

const FrontList = require('../pages/list')

import store from '../store'


let routes = [
    // Welcome
    {
        path: '/',
        name: 'welcome',
        component: () => import('../pages/welcome').then(m => m.default || m)
    },

    // Auth
    {
        path: '/login',
        name: 'login',
        component: () => import('../pages/auth/login').then(m => m.default || m)
    },

    // 2fa
    {
        path: '/2fa',
        name: '2fa',
        component: () => import('../pages/2fa/2fa').then(m => m.default || m)
    },

    // Home
    {
        path: '/home',
        name: 'home',
        component: () => import('../pages/home').then(m => m.default || m)
    },

    // Courier/Call Center

    {
        path: '/lending-points/stock',
        name: 'lending-points.stock',
        component: FrontList,
        meta: {
            roles: ['Call Center', 'Courier']
        },
        props: {
            plural: 'lending points stock',
            singular: 'lending points stock',
            slug: 'lending-points/stock',
            icon: 'local_shipping',
            columnsDef: 'stockColumns',
            directExportRoute: '/lending-points/stock/export'
        }
    },

    // Admin
    {
        path: '/admin',
        component: Step,
        children: [
        ]
            .concat(makeCRUDsRoutes('admin', [
                'LendingPointType',
                'LendingPointTrace',
                'ConsumerType',
                'NoSoldReason',
                'OrderStatus',
                'Role',
                //NOTE: ??
                'Market',
                'StockStatus',
                'Audit',
                'Owner',
                'ImdlMarketRoles'
            ], { role: 'Admin' }))
            .concat(makeCRUDsRoutes('admin', [
                'Origin',
                'User',
                'Template',
                'LendingPointCategory',
                'Configuration',
                'ConfigurationMarket',
                'ProductNotification',
                'ProblemFixer'
            ], { roles: ['Admin', 'Backoffice'] }))
    },

    // Backoffice
    {
        //backoffice/lending-point/import
        path: '/backoffice',
        component: Step,
        children: [
            {
                path: 'lending-point/export',
                name: 'backoffice.lending-point.export',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Sales Expert', 'MUPI','Remote Coach', 'Logista']
                },
                component: () =>  import('../' + getComponentPathForMarket('pages/backoffice/lending-point/export')).then(m => m.default || m)
            },
            {
                path: 'lending-point/import',
                name: 'backoffice.lending-point.import',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Sales Expert', 'MUPI', 'Remote Coach']
                },
                // component: () => import('../pages/backoffice/lending-point/import').then(m => m.default || m)
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-point/import')).then(m => m.default || m)
            },
            {
                path: 'lending-point/stockimport',
                name: 'backoffice.lending-point.stockimport',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-point/stockimport')).then(m => m.default || m)
            },
            {
                path: 'lending-point/:id/detail',
                name: 'backoffice.lending-point.detail',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-point/detail')).then(m => m.default || m)
            },
            {
                path: 'lending-point/:id/reverse-flow/:product?',
                name: 'backoffice.lending-point.reverse-flow',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-point/form-reverse-flow')).then(m => m.default || m)
            },
            {
                path: 'lending-kit/export',
                name: 'backoffice.lending-kit.export',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Courier', 'Call Center', 'Logista']
                },
                component: () =>  import('../' + getComponentPathForMarket('pages/backoffice/lending-kit/export')).then(m => m.default || m)
            },
            {
                path: 'lending-kit/import',
                name: 'backoffice.lending-kit.import',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Courier', 'Call Center', 'Logista']
                },
                component: () => import('../pages/backoffice/lending-kit/import').then(m => m.default || m)
            },
            {
                path: 'lending-kit/color-import',
                name: 'backoffice.lending-kit.colorimport',
                meta: {
                    roles: ['Admin', 'Backoffice', 'Courier', 'Call Center', 'Logista']
                },
                component: () => import('../pages/backoffice/lending-kit/color-import').then(m => m.default || m)
            },
            {
              path: 'lending-kit/change-status',
              name: 'backoffice.lending-kit.change-status',
              meta: {
                  roles: ['Backoffice']
              },
              component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-kit/import')).then(m => m.default || m)
            },
            {
                path: 'order/export',
                name: 'backoffice.order.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/order/export').then(m => m.default || m)
            },
            {
                path: 'audit/export',
                name: 'backoffice.audit.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/audit/export').then(m => m.default || m)
            },
            {
                path: 'order-movement/export',
                name: 'backoffice.order-movement.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/order-movement/export').then(m => m.default || m)
            },
            {
                path: 'stock-movement/export',
                name: 'backoffice.stock-movement.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/stock-movement/export').then(m => m.default || m)
            },
            {
                path: 'user/export',
                name: 'backoffice.user.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/user/export')).then(m => m.default || m)
            },
            // {
            //     path: 'market',
            //     name: 'backoffice.market.index',
            //     meta: {
            //         roles: ['Admin']
            //     },
            //     component: () => import('../pages/backoffice/market/management').then(m => m.default || m)
            // }
            {
                path: 'lending-point-open-integration/export',
                name: 'backoffice.lending-point-open-integration.export',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/lending-point-open-integration/export').then(m => m.default || m)
            },
            {
                path: 'lending-point-open-integration/import',
                name: 'backoffice.lending-point-open-integration.import',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../pages/backoffice/lending-point-open-integration/import').then(m => m.default || m)
            },
            {
                path: 'order/import',
                name: 'backoffice.order.import',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/order/import')).then(m => m.default || m)
            },
            {
                path: 'lending-point-category/:id/detail',
                name: 'backoffice.lending-point-category.detail',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-point-category/detail')).then(m => m.default || m)
            },

            {
                path: 'lending-point-category/:id/reverse-flow/:product?',
                name: 'backoffice.lending-point-category.reverse-flow',
                meta: {
                    roles: ['Admin', 'Backoffice']
                },
                component: () => import('../' + getComponentPathForMarket('pages/backoffice/lending-point-category/form-reverse-flow')).then(m => m.default || m)
            },
        ]
            .concat(makeCRUDsRoutes('backoffice', [
                'LendingKit',
            ], { roles: ['Admin', 'Backoffice', 'Courier', 'Call Center', 'Logista'] }))
            .concat(makeCRUDsRoutes('backoffice', [
                'Order',
                'OrderMovement',
                'Origin',
                'StockMovement',
                'ProductModel',
                'ProductColor',
                'ProductNotification',
                'ProblemFixer',
                'Partner',
                'LendingPointOpenIntegration',
                'OrderFinalizationMode',
                'LendingPointCategory',
                'Segmentation',
                'SanitizationType'
            ], { roles: ['Admin', 'Backoffice'] }))
            .concat(makeCRUDsRoutes('backoffice', [
                'LendingPoint',
            ], { roles: ['Admin', 'Backoffice', 'Sales Expert', 'MUPI', 'Remote Coach'] }))
    },

    // Call Center
    {
        path: '/call-center',
        component: Step,
        children: [
            {
                path: 'order',
                name: 'call-center.order',
                meta: {
                    roles: ['Call Center']
                },
                component: () => import('../pages/call-center/order').then(m => m.default || m)
            },
            {
                path: 'orders',
                name: 'call-center.orders',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'orders history',
                    singular: 'order',
                    slug: 'call-center/orders',
                    icon: 'shopping cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'call-center.orders.export'
                }
            },
            {
                path: 'orders/export',
                name: 'call-center.orders.export',
                meta: {
                    roles: ['Call Center']
                },
                component: () => import('../pages/call-center/order/export').then(m => m.default || m)
            },
            {
                path: 'orders/due',
                name: 'call-center.orders.due',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'due orders',
                    singular: 'due order',
                    slug: 'call-center/orders/due',
                    icon: 'alarm off',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order',
                    directExportRoute: '/call-center/order-due/export'
                }
            },
            {
                path: 'orders/will-due',
                name: 'call-center.orders.will-due',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'lendings that will due',
                    singular: 'lending that will due',
                    slug: 'call-center/orders/will-due',
                    icon: 'alarm',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order',
                    directExportRoute: '/call-center/order-will-due/export'
                }
            },
            {
                path: 'orders/closed-earlier',
                name: 'call-center.orders.closed-earlier',
                component: FrontList,
                meta: {
                    roles: ['Call Center']
                },
                props: {
                    plural: 'orders closed before lending end',
                    singular: 'order closed before lending end',
                    slug: 'call-center/orders/closed-earlier',
                    icon: 'history',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'call-center.order',
                    directExportRoute: '/call-center/order-closed-earlier/export'
                }
            },
            {
                path: 'consumer-registration',
                meta: {
                    roles: ['Call Center']
                },
                name: 'call-center.consumer-registration',
                component: () => import('../pages/call-center/consumer-registration').then(m => m.default || m)
            },
        ]
    },

    // Lending Point
    {
        path: '/lending-point',
        component: Step,
        children: [
            {
                path: 'order',
                name: 'lending-point.order',
                meta: {
                    roles: ['Lending Point']
                },
                component: () => import('../' + getComponentPathForMarket('pages/lending-point/order')).then(m => m.default || m)
            },
            {
                path: 'orders',
                name: 'lending-point.orders',
                component: FrontList,
                meta: {
                    roles: ['Lending Point']
                },
                props: {
                    slug: 'lending-point/orders',
                    singular: 'order',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point.order',
                    tabFilterDef: 'orderListTabs',
                    mobileColumnsDef: 'orderColumnsMobile'
                }
            },
            {
                path: 'orders/reserved',
                name: 'lending-point.orders.reserved',
                component: FrontList,
                meta: {
                    roles: ['Lending Point']
                },
                props: {
                    slug: 'lending-point/orders/reserved',
                    singular: 'call center reserved order',
                    plural: 'call center reserved orders',
                    icon: 'star',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point.order'
                }
            },
            {
                path: 'orders/in-lending',
                name: 'lending-point.orders.in-lending',
                component: FrontList,
                meta: {
                    roles: ['Lending Point']
                },
                props: {
                    slug: 'lending-point/orders/in-lending',
                    singular: 'order in lending',
                    plural: 'orders in lending',
                    icon: 'how to reg',
                    columnsDef: 'orderInLendingColumns',
                    detailComp: 'order-detail',
                    createRoute: 'lending-point.order',
                    mobileColumnsDef: 'orderInLendingColumnsMobile'
                }
            },
            {
                path: 'orders/external-return',
                name: 'lending-point.orders.external-return',
                // component: () => import('../pages/lending-point/externalReturn'),
                component: FrontList,
                meta : {
                    roles: ['Lending Point', 'Remote Coach', 'Sales Expert', 'MUPI']
                },
                props: {
                    slug: 'lending-point/orders/external-return',
                    singular: 'external return',
                    plural: 'external returns',
                    icon: 'assignment_return',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },
            {
                path: 'orders/reservation',
                name: 'lending-point.orders.reservation',
                // component: () => import('../pages/lending-point/externalReturn'),
                component: FrontList,
                meta : {
                    roles: ['Lending Point', 'Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'lending-point/orders/reservation',
                    singular: 'reservation',
                    plural: 'reservations',
                    icon: 'assignment_return',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },
            {
                path: 'lending-kits',
                name: 'lending-point.lending-kits',
                component: FrontList,
                meta: {
                    roles: ['Lending Point']
                },
                props: {
                    slug: 'lending-point/lending-kits',
                    singular: 'lending kit',
                    plural: 'lending kits stock',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    tabFilterDef: 'lendingKitTabFilters',
                    mobileColumnsDef: 'lendingKitColumnsMobile'
                }
            },
            {
                path: 'lending-kits/cleaning',
                name: 'lending-point.lending-kits.cleaning',
                component: FrontList,
                meta: {
                    roles: ['Lending Point']
                },
                props: {
                    slug: 'lending-point/lending-kits/cleaning',
                    singular: 'lending kits for maintenance',
                    plural: 'lending kit for maintenance',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },
            {
                path: 'lending-kits/pending-reception',
                name: 'lending-point.lending-kits.pending-reception',
                component: FrontList,
                meta: {
                    roles: ['Lending Point', 'Remote Coach', 'Sales Expert', 'MUPI']
                },
                props: {
                    slug: 'lending-point/lending-kits/pending-reception',
                    singular: 'lending kit pending to receive',
                    plural: 'lending kits pending to receive',
                    icon: 'import',
                    columnsDef: 'lendingKitPendingReceptionColumns',
                    detailComp: 'lending-kit-pending-reception-detail',
                    mobileColumnsDef: 'lendingKitPendingReceptionColumnsMobile'
                }
            },
            {
                path: 'lending-kits/add',
                name: 'lending-point.lending-kits.add',
                component: () => import('../' + getComponentPathForMarket('pages/device/addLendingKit')).then(m => m.default || m),
                meta: {
                    roles: ['Lending Point', 'Backoffice', 'Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'lending-point/lending-kits/add',
                    singular: 'lending kt',
                    plural: 'lending kits',
                    icon: 'how to vote',
                }
            },
            {
                path: 'lending-kits/clear',
                name: 'lending-point.clear',
                component: FrontList,
                meta: {
                    roles: ['Lending Point']
                },
                props: {
                    slug: 'lending-point/lending-kits/clear',
                    singular: 'lending kits for sanitization',
                    plural: 'lending kit for sanitization',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },

        ]
    },

    // Courier
    {
        path: '/courier',
        component: Step,
        children: [
            {
                path: 'orders',
                name: 'courier.orders',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders',
                    singular: 'order',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    exportRoute: 'courier.orders.export'
                }
            }, {
                path: 'orders/export',
                name: 'courier.orders.export',
                meta: {
                    roles: ['Courier']
                },
                component: () => import('../pages/courier/order/export').then(m => m.default || m)
            },
            {
                path: 'orders/reserved',
                name: 'courier.orders.reserved',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/reserved',
                    singular: 'delivery order',
                    plural: 'delivery orders',
                    icon: 'star',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },
            {
                path: 'orders/in-transit',
                name: 'courier.orders.in-transit',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/in-transit',
                    singular: 'in transit order',
                    plural: 'in transit orders',
                    icon: 'motorcycle',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },
            {
                path: 'orders/pending-pickup',
                name: 'courier.orders.pending-pickup',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/orders/pending-pickup',
                    singular: 'pending pickup order',
                    plural: 'pending pickup orders',
                    icon: 'undo',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail'
                }
            },
            {
                path: 'lending-kits',
                name: 'courier.lending-kits',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/lending-kits',
                    singular: 'lending kit',
                    plural: 'lending kits stock',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    directExportRoute: '/courier/lending-kit/export'
                }
            },
            {
                path: 'lending-kits/cleaning',
                name: 'courier.lending-kits.cleaning',
                component: FrontList,
                meta: {
                    roles: ['Courier']
                },
                props: {
                    slug: 'courier/lending-kits/cleaning',
                    singular: 'lending kit for maintenance',
                    plural: 'lending kits for maintenance',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },
        ]
    },

    // Sales Expert
    {
        path: '/sales-expert',
        component: Step,
        children: [
            {
                path: 'order',
                name: 'sales-expert.order',
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                component: () => import('../' + getComponentPathForMarket('pages/lending-point/order')).then(m => m.default || m)
                //component: () => import('../pages/lending-point/order').then(m => m.default || m)
            },
            {
                path: 'orders',
                name: 'sales-expert.orders',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/orders',
                    singular: 'order',
                    plural: 'orders history',
                    icon: 'shopping_cart',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'sales-expert.order',
                    tabFilterDef: 'orderListTabs',
                    mobileColumnsDef: 'orderColumnsMobile'
                }
            },
            {
                path: 'orders/reserved',
                name: 'sales-expert.orders.reserved',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/orders/reserved',
                    singular: 'call center reserved order',
                    plural: 'call center reserved orders',
                    icon: 'star',
                    columnsDef: 'orderColumns',
                    detailComp: 'order-detail',
                    createRoute: 'sales-expert.order'
                }
            },
            {
                path: 'orders/in-lending',
                name: 'sales-expert.orders.in-lending',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/orders/in-lending',
                    singular: 'order in lending',
                    plural: 'orders in lending',
                    icon: 'how to reg',
                    columnsDef: 'orderInLendingColumns',
                    detailComp: 'order-detail',
                    createRoute: 'sales-expert.order',
                    mobileColumnsDef: 'orderInLendingColumnsMobile'
                }
            },
            {
                path: 'lending-kits',
                name: 'sales-expert.lending-kits',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/lending-kits',
                    singular: 'lending kit',
                    plural: 'lending kits stock',
                    icon: 'how_to_vote',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    tabFilterDef: 'lendingKitTabFilters',
                    mobileColumnsDef: 'lendingKitColumnsMobile'
                }
            },
            {
                path: 'lending-kits/clear',
                name: 'sales-expert.clear',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/lending-kits/clear',
                    singular: 'lending kits for sanitization',
                    plural: 'lending kit for sanitization',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },
            {
                path: 'lending-kits/cleaning',
                name: 'sales-expert.lending-kits.cleaning',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/lending-kits/cleaning',
                    singular: 'lending kits for maintenance',
                    plural: 'lending kit for maintenance',
                    icon: 'phonelink_setup',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail'
                }
            },
            {
                path: 'lending-kits/pending-reception',
                name: 'sales-expert.lending-kits.pending-reception',
                component: FrontList,
                meta: {
                    roles: ['Sales Expert', 'MUPI', 'Remote Coach']
                },
                props: {
                    slug: 'sales-expert/lending-kits/pending-reception',
                    singular: 'lending kits pending to receive',
                    plural: 'lending kit pending to receive',
                    icon: 'import',
                    columnsDef: 'lendingKitColumns',
                    detailComp: 'lending-kit-detail',
                    mobileColumnsDef: 'lendingKitPendingReceptionColumnsMobile'
                }
            },
        ]
    },

    //Remote Coach
    /*{
        path: '/remote-coach',
        component: Step,
        children: [
            {
                path: 'reservation',
                name: 'remote-coach.reservation',
                meta: {
                    roles: ['Remote Coach']
                },
                // component: () => import('../pages/remote-coach/order').then(m => m.default || m)
                component: () => import('../' + getComponentPathForMarket('pages/lending-point/order')).then(m => m.default || m)
            },
        ]
    },*/
    // Devices
    {
        path: '/device',
        name: 'device',
        component: () => import('../pages/device/importDevices').then(m => m.default || m)
    },

    // Errors
    {
        path: '/no-lending-point',
        name: 'error-4001',
        component: require('../pages/errors/4001.vue')
    },
    {
        path: '/no-ad-group',
        name: 'error-4002',
        component: require('../pages/errors/4002.vue')
    },
    {
        path: '/no-user-in-app',
        name: 'error-4003',
        component: require('../pages/errors/4003.vue')
    },
    {
        path: '/wrong-market',
        name: 'error-4004',
        component: require('../pages/errors/4004.vue')
    },
    {
        path: '/no-user-role-imdl',
        name: 'error-4005',
        component: require('../pages/errors/4005.vue')
    },

    // Catch all
    {
        path: '*',
        component: require('../pages/errors/404.vue')
    }
]

export default routes

function makeCRUDsRoutes (path, resources, meta) {
    let routes = []
    resources.forEach(resource => {
        var parts = resource.split('\\').map(part => changeCase.paramCase(part))
        var slug = parts.join('/')
        var name = parts.join('.')
        var baseRoute = `${path}.${name}`
        routes.push({
            path: slug,
            name: `${baseRoute}.index`,
            component: List,
            meta,
            props: { slug, baseRoute }
        })
        routes.push({
            path: `${slug}/form`,
            name: `${baseRoute}.create`,
            component: AutoForm,
            meta,
            props: { slug, baseRoute }
        })
        routes.push({
            path: `${slug}/form/:id`,
            name: `${baseRoute}.edit`,
            component: AutoForm,
            meta,
            props: { slug, baseRoute }
        })
    })
    return routes
}

/**
 * Returns the path of the market component, based on the user's market.
 * @param componentPath
 */
function getComponentPathForMarket (componentPath) {
    var authUser = store.getters['auth/user'];
    var userMarket;
    var fullPath;
    
    //Is the user associated with any market?
    if (authUser && authUser.market_id != null) {
        userMarket = authUser.market.abbreviation;
        fullPath = 'markets/' + userMarket + '/' + componentPath;

        try {
            require('../' + fullPath);
        } catch (e) {
            return componentPath; //No market component found. Return the base.
        }
        return fullPath;
    }
    else {
        return componentPath;
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js